const getPickupAvailability = (productInfo, bossEnabled) => {
  const { bopsAvailability, bossAvailability } = productInfo || {};
  const isBossUpc = !bopsAvailability && bossAvailability && bossEnabled;
  const isAvailableForPickup = isBossUpc || bopsAvailability;
  return {
    isBossUpc,
    isAvailableForPickup,
  };
};

export default getPickupAvailability;
